export function pullValidQtyTypes(ingredient, qtyTypes) {
    if (!ingredient.conversionMap) return []
    const currentUnit = ingredient.conversionMap[ingredient.qtyType]?.unit
    // If current qtyType isn't in conversionMap, find types that share the most common unit
    if (!currentUnit) {
        // Get all available types from conversionMap that are in qtyTypes
        return Object.entries(ingredient.conversionMap)
            .filter(([key]) => key in qtyTypes)
            .map(([key]) => ({qtyType: key, qtyTypeNice: qtyTypes[key]}))
    }
    return Object.entries(ingredient.conversionMap)
        .filter(([key, val]) => val.unit === currentUnit && key in qtyTypes)
        .map(([key]) => ({qtyType: key, qtyTypeNice: qtyTypes[key]}))
}
export function combineIngredientAndDetails(ingredients, ingredientDetails, qtyTypes){

    ingredients = ingredients.map((x) => {
        Object.assign(x, ingredientDetails[x.ingredientId])
        if(qtyTypes) {
            x.validTypes = pullValidQtyTypes(x, qtyTypes)
        }
        return x
    });
    return ingredients
}
export function convertType(ingredient, target) {
    const map = ingredient.conversionMap
    if (!map) return ingredient.qty

    const from = map[ingredient.qtyType]
    const to = map[target]
    if (!from || !to) return ingredient.qty
    if (from.unit !== to.unit) return ingredient.qty

    return ingredient.qty * from.factor / to.factor
}
